<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-3" role="tab">
        <span class="m-1">Data Mitra</span>
        <b-button v-b-toggle.accordion-1 variant="yellow" class="chevron">
          <span class="when-open">
            <b-icon icon="chevron-up" />
          </span>
          <span class="when-closed">
            <b-icon icon="chevron-down" />
          </span>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <div class="container">
              <div v-if="isLoadingLoadData" class="text-center my-4">
                <b-spinner label="Loading..." variant="primary" small></b-spinner>
                <p>Memuat data, mohon tunggu...</p>
              </div>
              <div role="group">
                <b-form-textarea-with-mask
                  v-model="form.alamat_mitra"
                  label="Alamat Mitra :"
                  :mask="true"
                  :rows="3"
                  :disabled="isDisabled"
                />
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="provinsi">Provinsi</label>
                      <br />
                      <b-form-select 
                        v-model="form.provinsi" 
                        :value.sync="form.provinsi" 
                        :options="options.provinsi"
                        @input="provinsiChange" 
                        :disabled="isDisabled"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kota">Kota / Kabupaten</label>
                      <br />
                      <b-form-select 
                        v-model="form.kota" 
                        :value.sync="form.kota" 
                        :options="options.kota" 
                        @input="kotaChange" 
                        :disabled="isDisabled || loadingchangeProvince"
                      ></b-form-select>
                      <small
                        v-if="loadingchangeProvince"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px;"
                      >
                        <b-spinner small type="grow" class="mr-1" style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                        memuat data kota...
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kecamatan">Kecamatan</label>
                      <br />
                      <b-form-select 
                        v-model="form.kecamatan" 
                        :value.sync="form.kecamatan" 
                        :options="options.kecamatan" 
                        @input="kecamatanChange" 
                        :disabled="isDisabled || loadingKotaChange"
                      ></b-form-select>
                      <small
                        v-if="loadingKotaChange"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px;"
                      >
                        <b-spinner small type="grow" class="mr-1" style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                        memuat data kecamatan...
                      </small>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="desa">Desa / Kelurahan</label>
                      <br />
                      <b-form-select 
                        v-model="form.kelurahan" 
                        :value.sync="form.kelurahan" 
                        :options="options.kelurahan" 
                        :disabled="isDisabled || loadingKecamatanChange"
                      ></b-form-select>
                      <small
                        v-if="loadingKecamatanChange"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px;"
                      >
                        <b-spinner small type="grow" class="mr-1" style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                </div>

                <b-card class="mb-3 mt-3">
                  <b-row>
                    <b-col>
                      <FormInput
                        type="image"
                        label="Logo Mitra"
                        :value="thumbnailLogo"
                        @input="val => { thumbnailLogo = val; form.logo_mitra = val; }"
                        :previewFile="thumbnailLogo"
                        :disabled="isDisabled"
                      />
                    </b-col>
                  </b-row>
                </b-card>

                <!-- Informasi Akta -->
                <b-card class="mb-3">
                  <b-row>
                    <b-col>
                      <BFormInputWithMask
                        type="number"
                        v-model="form.no_akta_pendirian"
                        placeholder="Nomor Akta Pendirian"
                        label="Nomor Akta Pendirian"
                        @blur="handleBlur(`deed_number`)"
                        :required="true"
                        :disabled="isDisabled"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <FormInput
                        type="file"
                        label="Akta Pendirian"
                        :value="display.akta_pendirian"
                        @input="val => handleFileInput('akta_pendirian', val)"
                        :previewFile="display.akta_pendirian"
                        :disabled="isDisabled"
                        :maxSize="20"
                      />
                    </b-col>
                    <b-col>
                      <FormInput
                        type="file"
                        label="Akta Perubahan Terakhir"
                        :value="display.akta_terakhir"
                        @input="val => handleFileInput('akta_terakhir', val)"
                        :previewFile="display.akta_terakhir"
                        :disabled="isDisabled"
                        :maxSize="20"
                      />
                    </b-col>
                  </b-row>
                </b-card>
                <b-card class="mb-3">
                  <b-row>
                    <b-col>
                      <FormInput
                        type="file"
                        label="SK Kemenkumham Pendirian"
                        :value="display.sk_pendirian"
                        @input="val => handleFileInput('sk_pendirian', val)"
                        :previewFile="display.sk_pendirian"
                        :disabled="isDisabled"
                        :maxSize="20"
                      />
                    </b-col>
                    <b-col>
                      <FormInput
                        type="file"
                        label="SK Kemenkumham Terakhir"
                        :value="display.sk_terakhir"
                        @input="val => handleFileInput('sk_terakhir', val)"
                        :previewFile="display.sk_terakhir"
                        :disabled="isDisabled"
                        :maxSize="20"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </div>

              <b-spinner v-if="isLoading" variant="primary" class="mt-3"></b-spinner>

              <b-button
                v-else-if="user && user.id !== user.mitra_id"
                variant="success"
                @click.prevent="updateProfile"
                class="btn btn-custom theme-color mr-md-2 mr-auto px-4 mt-3"
              >
                Simpan
              </b-button>

              <b-modal size="sm" v-model="confirmUpdateModal" hide-footer hide-header>
                <div v-if="!isLoading">
                  <div class="d-block text-center">
                    <h3>Apakah Anda yakin ingin menyimpan Data Mitra?</h3>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-button class="mt-3" block @click="confirmUpdateProfile">Ya</b-button>
                    </div>
                    <div class="col">
                      <b-button class="mt-3" block @click="confirmUpdateModal = false">Tidak</b-button>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center">
                  <b-spinner variant="primary"></b-spinner>
                  <p>Sedang memproses...</p>
                </div>
              </b-modal>

              <b-modal size="sm" v-model="successModal" hide-footer hide-header>
                <div class="d-block text-center">
                  <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
                  <h3>{{ modalText }}</h3>
                </div>
                <div class="row">
                  <div class="col">
                    <b-button class="mt-3" block @click="onCloseSuccessModal">Tutup</b-button>
                  </div>
                </div>
              </b-modal>
              <b-modal size="sm" v-model="errorModal" hide-footer hide-header>
                <div class="text-center">
                  <b-icon icon="exclamation-circle" animation="throb" variant="danger" style="width: 120px; height: 120px;"></b-icon>
                  <h3>Gagal Mengupdate Profil</h3>
                  <p class="text-muted">{{ errorText }}</p>
                  <b-button class="mt-3" block @click="errorModal = false">Tutup</b-button>
                </div>
              </b-modal>
            </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <UbahPassword />

    <VerifikasiEmail />
  </div>
</template>

<script>
import MitraProfile from "../../api/mitraprofile";
import Provinsi from "../../api/daerahindonesia/provinsi";
import Kota from "../../api/daerahindonesia/kota";
import Kecamatan from "../../api/daerahindonesia/kecamatan";
import Kelurahan from "../../api/daerahindonesia/kelurahan";
import UbahPassword from "./ubah-password";
import VerifikasiEmail from "./verifikasi-email";
import BFormInputWithMask from "../../components/masking-input.vue"
import BFormTextareaWithMask from "../../components/masking-text-area.vue"
import FormInput from "../pengajuan-saya/FormInput.vue";

export default {
  name: "ProfilMitra",
  components: {
    UbahPassword,
    VerifikasiEmail,
    BFormInputWithMask,
    BFormTextareaWithMask,
    FormInput
  },
  data() {
    return {
      isLoading: false,
      form: {
        alamat_mitra: "",
        no_akta_pendirian: "",
        provinsi: null,
        kota: null,
        kecamatan: null,
        kelurahan: null,
        logo_mitra: null,
        akta_pendirian: null,
        akta_terakhir: null,
        sk_pendirian: null,
        sk_terakhir: null
      },
      display: {
        akta_pendirian: null,
        akta_terakhir: null,
        sk_pendirian: null,
        sk_terakhir: null
      },
      thumbnailLogo: null,
      confirmUpdateModal: false,
      successModal: false,
      errorModal: false,
      modalText: "",
      errorText: "",
      isUploadedLogo: false,
      options: {
        provinsi: [],
        kota: [],
        kecamatan: [],
        kelurahan: []
      },
      isChangeLogo: false,
      user: null,
      api_url: null,
      isLoadingLoadData: false
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isDisabled() {
      return this.user && this.user.id == this.user.mitra_id;
    }
  },
  methods: {
    async loadData() {
      this.isLoadingLoadData = true;
      this.api_url = process.env.API_URL;
      let profile = this.currentUser.info;
      this.user = profile;
      try {
        const res = await MitraProfile.show(profile.mitra_id);
        const data = res.data.data;
        this.form = {
          alamat_mitra: data.alamat_mitra,
          provinsi: data.provinsi,
          kota: data.kota,
          kecamatan: data.kecamatan,
          kelurahan: data.kelurahan,
          no_akta_pendirian: data.no_akta_pendirian
        };
        this.display = {
          akta_pendirian: data.akta_pendirian,
          akta_terakhir: data.akta_terakhir,
          sk_pendirian: data.sk_pendirian,
          sk_terakhir: data.sk_terakhir
        };
        if (data.logo_mitra) {
          this.isUploadedLogo = true;
          this.thumbnailLogo = `${data.logo_mitra}`;
        }

        // Ambil data provinsi
        const responseProvinsi = await this.$getListWilayah('provinsi');
        const provinsiArray = responseProvinsi.data || [];
        const arrData = provinsiArray.map(item => ({
          value: item.id,
          text: item.name
        }));
        this.options.provinsi = arrData;
        // Ambil data kota/kabupaten
        if (data.provinsi) {
          this.kotaChange();
        }
        // Ambil data kecamatan
        if (data.kota) {
          this.kecamatanChange();
        }
        // Ambil data kelurahan
        if (data.kecamatan) {
          this.kelurahanChange();
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.isLoadingLoadData = false;
      }
    },
    onCloseSuccessModal() {
      this.successModal = false;

      this.$router.go(0); 
    },
    handleFileInput(field, val) {
      // val = base64 dari komponen
      this.display[field] = val;

      // Convert base64 ke File object
      const file = this.base64ToFile(val, `${field}.pdf`);
      this.form[field] = file;
    },
    base64ToFile(base64, filename) {
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    getFileName(filePath) {
      return filePath.split("/").pop();
    },
    logoChange(e) {
      const file = e.target.files[ 0 ];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = res => {
        this.thumbnailLogo = res.target.result;
        this.isUploadedLogo = true;
        this.isChangeLogo = true;
      };
    },
    handleFileChange(field, event) {
      this.form[ field ] = event.target.files[ 0 ];
    },
    async confirmUpdateProfile() {
      this.isLoading = true;
      this.confirmUpdateModal = false;

      try {
        // 🔹 Mapping field ke label form
        const fieldLabels = {
          logo_mitra: "Logo Mitra",
          akta_pendirian: "Akta Pendirian",
          akta_terakhir: "Akta Perubahan Terakhir",
          sk_pendirian: "SK Kemenkumham Pendirian",
          sk_terakhir: "SK Kemenkumham Terakhir"
        };

        // 🔹 Validasi ukuran file sebelum proses
        const validateFileSize = (field, file, maxSizeMB) => {
          if (file && file.size > maxSizeMB * 1024 * 1024) {
            throw new Error(
              `${fieldLabels[field]} melebihi batas ${maxSizeMB}MB`
            );
          }
        };

        // Validasi semua file sesuai jenisnya
        if (this.isChangeLogo && this.form.logo_mitra) {
          validateFileSize("logo_mitra", this.form.logo_mitra, 5); // gambar max 5MB
        }
        if (this.form.akta_pendirian) {
          validateFileSize("akta_pendirian", this.form.akta_pendirian, 30); // pdf max 30MB
        }
        if (this.form.akta_terakhir) {
          validateFileSize("akta_terakhir", this.form.akta_terakhir, 30);
        }
        if (this.form.sk_pendirian) {
          validateFileSize("sk_pendirian", this.form.sk_pendirian, 30);
        }
        if (this.form.sk_terakhir) {
          validateFileSize("sk_terakhir", this.form.sk_terakhir, 30);
        }

        // 🔹 Kalau lolos validasi → proses ke base64
        const payload = { ...this.form };
        const readFileAsBase64 = file =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          });

        if (this.isChangeLogo && this.form.logo_mitra) {
          payload.logo_mitra = await readFileAsBase64(this.form.logo_mitra);
        }
        if (this.form.akta_pendirian) {
          payload.akta_pendirian = await readFileAsBase64(this.form.akta_pendirian);
        }
        if (this.form.akta_terakhir) {
          payload.akta_terakhir = await readFileAsBase64(this.form.akta_terakhir);
        }
        if (this.form.sk_pendirian) {
          payload.sk_pendirian = await readFileAsBase64(this.form.sk_pendirian);
        }
        if (this.form.sk_terakhir) {
          payload.sk_terakhir = await readFileAsBase64(this.form.sk_terakhir);
        }

        // 🔹 Kirim data ke API
        const res = await MitraProfile.updateV3(payload);
        if (res.data.meta.code === 200) {
          this.successModal = true;
          this.modalText = "Profil berhasil diubah.";
          this.loadData();
        } else {
          this.errorModal = true;
          this.errorText = res.data.meta.message || "Gagal mengupdate profil.";
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        this.errorModal = true;
        this.errorText = error.message || "Terjadi kesalahan saat mengupdate profil.";
      } finally {
        this.isLoading = false;
      }
    },
    updateProfile() {
      this.confirmUpdateModal = true;
    },
    async provinsiChange() {
      this.loadingchangeProvince = true;
      // this.form.kota = null;
      try {
        const responseKota = await this.$getListWilayah('kota', this.form.provinsi);
          const kotaArray = responseKota.data || [];
          const arrData = kotaArray.map(item => ({
            value: item.id,
            text: item.name
          }));
          this.options.kota = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingchangeProvince = false;
      }
    },
    async kotaChange() {
      this.loadingKotaChange = true;
      // this.form.kecamatan = null;
      try {
        const responseKecamatan = await this.$getListWilayah('kecamatan', this.form.kota);
          const kecamatanArray = responseKecamatan.data || [];
          const arrData = kecamatanArray.map(item => ({
            value: item.id,
            text: item.name
          }));
          this.options.kecamatan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKotaChange = false;
      }
    },
    async kecamatanChange() {
      this.loadingKecamatanChange = true;
      // this.form.kelurahan = null;
      try {
        const responseKelurahan = await this.$getListWilayah('kelurahan', this.form.kecamatan);
          const kelurahanArray = responseKelurahan.data || [];
          const arrData = kelurahanArray.map(item => ({
            value: item.id,
            text: item.name
          }));
          this.options.kelurahan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKecamatanChange = false;
      }
    }
  }
};
</script>

<style scoped>
img {
  font-family: "Helvetica";
  font-weight: 300;
  line-height: 2;
  text-align: center;
  width: 30%;
  height: auto;
  display: block;
  position: relative;
  min-height: 50px;
}

.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}

.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}

img:before {
  content: " ";
  display: block;
  position: absolute;
  top: -10px;
  left: 0;
  height: calc(100% + 10px);
  width: 30%;
  background-color: rgb(230, 230, 230);
  border: 2px dotted rgb(200, 200, 200);
  border-radius: 5px;
}

img:after {
  content: "\f127" " Foto " attr(alt) " Tidak Ditemukan :(";
  display: block;
  font-size: 16px;
  font-style: normal;
  font-family: FontAwesome;
  color: rgb(100, 100, 100);
  position: absolute;
  top: 5px;
  left: 0;
  width: 30%;
  text-align: center;
}

.collapsed>.when-open,
.not-collapsed>.when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/profil-mitra.vue